import React, { createContext, useContext, useState, useCallback } from 'react';

interface StorageContextType {
  refreshStorage: () => void;
  storageKey: number;
  pendingStorageChange: number; // Temporary storage change before API confirms
  setPendingStorageChange: (change: number) => void;
  clearPendingStorageChange: () => void;
}

const StorageContext = createContext<StorageContextType | undefined>(undefined);

export const StorageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [storageKey, setStorageKey] = useState(0);
  const [pendingStorageChange, setPendingStorageChange] = useState(0);

  const refreshStorage = useCallback(() => {
    // Increment key to force re-render of all storage displays
    console.log("Refreshing storage display");
    setStorageKey(prev => {
      const newKey = prev + 1;
      console.log("New storage key:", newKey);
      return newKey;
    });
  }, []);

  const clearPendingStorageChange = useCallback(() => {
    setPendingStorageChange(0);
  }, []);

  return (
    <StorageContext.Provider value={{ 
      refreshStorage, 
      storageKey, 
      pendingStorageChange,
      setPendingStorageChange,
      clearPendingStorageChange
    }}>
      {children}
    </StorageContext.Provider>
  );
};

export const useStorageRefresh = () => {
  const context = useContext(StorageContext);
  if (!context) {
    // Return a no-op function if context is not available
    return { 
      refreshStorage: () => {}, 
      storageKey: 0,
      pendingStorageChange: 0,
      setPendingStorageChange: () => {},
      clearPendingStorageChange: () => {}
    };
  }
  return context;
};
